module.exports = __webpack_public_path__ + "Package.b17078af8dacc25c703f3b62fd6a32a9.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/getting-started/Package.svg
// module id = 1682904795690220
// module chunks = 1